import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemQuickViewComponent } from './item-quick-view.component';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { LoadingModule } from '../loading/loading.module';
import { AnvogueItemQuickViewModule } from '@storefront/ng.themes';


@NgModule({
  declarations: [
    ItemQuickViewComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    LoadingModule,
    AnvogueItemQuickViewModule
  ],
  exports: [
    ItemQuickViewComponent,
  ]
})
export class ItemQuickViewModule { }
